/* REMOVE FAVS */
export const REMOVE_FAV = "REMOVE_FAV"
export const REMOVE_FAV_SUCCESS = "REMOVE_FAV_SUCCESS"
export const REMOVE_FAV_CLEAN = "REMOVE_FAV_CLEAN"
export const REMOVE_FAV_ERROR = "REMOVE_FAV_ERROR"
